import { inject, Injectable } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MellisaAddressService {
  public formatedAddress: IMellisaAddress = {} as IMellisaAddress;

  private http = inject(HttpClient);

  getAddress(input: string, options: IMellisaOptions) {
    if (!input || !input.trim()) {
      return of([]);
    }

    return this.http
      .get(options.url, {
        params: new HttpParams()
          .set('id', options.key)
          .set('address1', input)
          .set('country', options.isoCountry)
          .set('maxrecords', options.maxRecords.toString())
          .set('nativecharset', options.nativeCharset.toString())
          .set('format', options.format),
        headers: new HttpHeaders().set('Skip-Token', '')
      })
      .pipe(
        map((res) => (res as never)['Results']),
        catchError(() => {
          return of([]);
        })
      );
  }
}

interface IMellisaOptions {
  url: string;
  key: string;
  isoCountry: string;
  maxRecords: number;
  nativeCharset: boolean;
  format: string;
}

export interface IMellisaAddress {
  superAdministrativeArea: string;
  locality: string;
  thoroughfare: string;
  stateId: string;
  postalCode: string;
  premise: string;
  postBox: string;
}
